"use strict";
import Cookies from "js-cookie";
const ONBOARDING_COOKIE_EXPIRY = 365;
const DATA_KEY = "onboarding";
export default function setOnboardingAction(element) {
  element.addEventListener("mousedown", () => {
    const action = element.dataset.onboardingActionValue;
    const model = element.dataset.onboardingModelValue;
    const permissionsHolder = element.dataset.onboardingPermissionsHolderValue;
    const redirectPath = element.dataset.onboardingRedirectPathValue;
    Cookies.set(DATA_KEY, JSON.stringify({ action, model, permissionsHolder, redirectPath }), {
      expires: ONBOARDING_COOKIE_EXPIRY
    });
  });
}
